import routerOptions0 from "/Users/duncandeklerk/Dev/ProjectsVue/airabica/airabica-nuxtapp/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}